module.exports = __webpack_public_path__ + "img/WPR.248ca276.svg";